<template>
  <div>
    <h3>Parental Controls</h3>
    <template v-if="!user.parental_controls_enabled">
      <p>Restrict Nanome Web Browser content with a 4 digit passcode.</p>
      <p>
        You can unlock this restriction for a single session in the app by using
        this passcode.
      </p>
    </template>
    <p v-else>
      Please enter your 4 digit passcode to disable parental controls.
    </p>

    <form @submit.prevent="submit">
      <NanInput
        v-model="code"
        prepend-icon="icon-key"
        placeholder="Passcode"
        aria-label="Passcode"
        class="mt-4 mx-auto"
        type="password"
        @input="parseCode('code')"
      />

      <NanInput
        v-if="!user.parental_controls_enabled"
        v-model="recode"
        prepend-icon="icon-key"
        placeholder="Repeat Passcode"
        aria-label="Repeat Passcode"
        class="mt-2 mx-auto"
        type="password"
        @input="parseCode('recode')"
      />

      <div class="text-center mt-4">
        <b-btn
          :disabled="!canSubmit"
          class="px-4"
          type="submit"
          variant="primary"
        >
          {{ user.parental_controls_enabled ? "Disable" : "Enable" }}
          Parental Controls
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import API from "@/api";

export default {
  props: {
    modal: Object
  },

  data: () => ({
    code: "",
    recode: ""
  }),

  computed: {
    ...mapState(["user"]),

    canSubmit() {
      const m =
        this.user.parental_controls_enabled || this.code === this.recode;
      return this.code.toString().length === 4 && m;
    }
  },

  methods: {
    parseCode(key) {
      this[key] = this[key]
        .toString()
        .replace(/\D/g, "")
        .slice(0, 4);
    },

    reset() {
      this.code = "";
      this.recode = "";
    },

    async submit() {
      if (!this.canSubmit) return;
      const enable = !this.user.parental_controls_enabled;
      const { success } = await API.updateParentalControls(enable, this.code);
      if (success) {
        this.$emit("hide");
        this.$notify({
          type: "success",
          text: `Parental controls ${enable ? "enabled" : "disabled"}.`
        });
        setTimeout(() => {
          this.reset();
          this.$store.dispatch("user/restoreSession");
        }, 300);
      }
    }
  }
};
</script>
